export default function phoneNumber(phoneNumberString: string) {
    var numberString = phoneNumberString.replace(/[-]/g, "");
    return new RegExp("^[0][9][0-9][0-9]{8,8}$").test(numberString);
}
